import pageContext from 'salvo-lite/context'

import bodyOverlay from './components/BodyOverlay'
import SiteHeader from './components/SiteHeader'
import escSlider from './components/Slider'
import beforeAndAfter from './components/BeforeAndAfter'
import instagram from './components/Instagram'
import reveal from './components/Reveal'
import loadMore from './components/LoadMore'
import SelectURL from './components/SelectURL'
import Video from './components/Video'
import VideoAccordion from './components/VideoAccordion'
import Accordion from './components/Accordion'
import Tabs from './components/Tabs'
import QuantitySelector from './components/QuantitySelector'
import ProductStickyBar from './components/ProductStickyBar'
import RecentlyViewed from './components/RecentlyViewed'
import Lookbook from './components/Lookbook'
import ProductModal from './components/ProductModal'
import ThreeSixty from './components/ThreeSixty'
import Popup from './components/Popup'
import Parallax from './components/Parallax'
import AjaxCart from './components/AjaxCart'
import CookieBanner from './components/CookieBanner'
import GEOIP from './components/GEOIP'
import ReadMore from './components/ReadMore'
import YouTubePlayer from './components/YouTubePlayer'
import Validation from './components/Validation'
import PaymentMethods from './components/PaymentMethods'
import CartStorage from './components/CartStorage'
import CheckoutBc from './components/CheckoutBc'
import CheckSwitch from './components/CheckSwitch'
import FakeClick from './components/FakeClick'

import index from './pages/Index'
import collection from './pages/Collection'
import BlogAndSearch from './pages/BlogAndSearch'
import Article from './pages/Article'
import pageCollections from './pages/pageCollections'
import Cart from './pages/Cart'
import Product from './pages/Product'
import Results from './pages/Results'
import Checkout from './pages/Checkout'
import Videos from './pages/Videos'
import ProductFinder from './pages/PageProductFinder'

const components = {
    'body-overlay': bodyOverlay,
    'site-header': SiteHeader,
    'slider': escSlider,
    'beforeAndAfter': beforeAndAfter,
    'instagram': instagram,
    'reveal': reveal,
    'load-more': loadMore,
    'select-url': SelectURL,
    'video': Video,
    'video-accordion': VideoAccordion,
    'accordion': Accordion,
    'tabs': Tabs,
    'quantity-selector': QuantitySelector,
    'product-sticky-bar': ProductStickyBar,
    'recently-viewed': RecentlyViewed,
    'lookbook': Lookbook,
    'product-modal': ProductModal,
    'three-sixty': ThreeSixty,
    'popup': Popup,
    'parallax': Parallax,
    'ajax-cart': AjaxCart,
    'cookie-banner': CookieBanner,
    'geoip': GEOIP,
    'read-more': ReadMore,
    'youtube-player': YouTubePlayer,
    'validation': Validation,
    'payment-methods': PaymentMethods,
    'cart-storage': CartStorage,
    'checkout-bc': CheckoutBc,
    'check-switch': CheckSwitch,
    'fake-click': FakeClick
}

const pages = {
    'index': index,
    'collection': collection,
    'blog': BlogAndSearch,
    'search.blog': BlogAndSearch,
    'article': Article,
    'cart': Cart,
    'page.collections': pageCollections,
    'product': Product,
    'page.results': Results,
    'checkout': Checkout,
    'page.videos': Videos,
    'page.product-finder': ProductFinder
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}
    }

    registerComponents () {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = document.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/scripts/Theme.js